import { useApp } from '../store';

export function Credits() {
  const setScreen = useApp((s) => s.setScreen);
  return (
    <div className="menu-bg">
      <div className="menu-card" style={{ maxWidth: 640 }}>
        <h2>Credits</h2>
        <p>Four Crowns is an original browser-native real-time strategy game.</p>
        <p className="muted">All 3D models, textures, sound effects and music are generated procedurally at runtime by the game's own code. The only drawn artwork is the crown on the title screen.</p>
        <p className="muted">Built with TypeScript, Three.js (MIT), React (MIT), Zustand (MIT) and Vite (MIT).</p>
        <p className="muted">Civilisations are historically inspired and simplified for gameplay. Later ages for some civilisations follow an explicitly alternate-history progression (see in-game civilisation notes).</p>
        <p>© 2026 MaxApex Studio. All rights reserved.</p>
        <button className="btn" onClick={() => setScreen('menu')}>Back</button>
      </div>
    </div>
  );
}
